import widgets from '../../widgets';
import { TooltipKey } from '../../machinelogic_tooltips';
/**
 * the state name widget for fsm states
 * @param {Object} params
 * @param {string} params.stateName
 * @param {() => void} params.onStateNameChange
 * @param {boolean} params.isInitialState
 * @returns {JQuery<HTMLElement>}
 */
export const stateNameWidget = ({stateName, onStateNameChange, isInitialState}) => {
  const lWidget = widgets.stringWidget(
    'State',
    'State Name',
    stateName,
    onStateNameChange,
    null,
    {tooltipKey: TooltipKey.FSM_STATE}
  )
    .addClass('ml_fsm_state_name_input');

  if(isInitialState) {
    const lInitialStateFlag = $('<div>').html('Initial<br>State').addClass('ml_fsm_initial_state_flag');
    lWidget.append(lInitialStateFlag);
  }
  return lWidget;
};
